"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandStatus = exports.Unit = exports.TimeFrame = void 0;
var TimeFrame;
(function (TimeFrame) {
    TimeFrame["Yearly"] = "Yearly";
    TimeFrame["Monthly"] = "Monthly";
    TimeFrame["Daily"] = "Daily";
    TimeFrame["Weekly"] = "Weekly";
    TimeFrame["Hourly"] = "Hourly";
    TimeFrame["HalfHourly"] = "HalfHourly";
})(TimeFrame = exports.TimeFrame || (exports.TimeFrame = {}));
var Unit;
(function (Unit) {
    Unit[Unit["kW"] = 1000] = "kW";
    Unit[Unit["kWh"] = 1000] = "kWh";
    Unit[Unit["MW"] = 1000000] = "MW";
    Unit[Unit["MWh"] = 1000000] = "MWh";
    Unit[Unit["GW"] = 1000000000] = "GW";
    Unit[Unit["GWh"] = 1000000000] = "GWh";
})(Unit = exports.Unit || (exports.Unit = {}));
var DemandStatus;
(function (DemandStatus) {
    DemandStatus["ACTIVE"] = "ACTIVE";
    DemandStatus["PAUSED"] = "PAUSED";
    DemandStatus["ARCHIVED"] = "ARCHIVED";
})(DemandStatus = exports.DemandStatus || (exports.DemandStatus = {}));
//# sourceMappingURL=EnumExports.js.map